import { AutoDispatchMode } from 'src/components/dispatch/autoDispatch/normalizeResponse';

export type CompletionKind = 'immediate' | 'queued' | 'skipped';

export type CompletionEffects = {
  /** override 2 つを消し、hasQueuedOverrideChangeRef を false にするか */
  clearOverride: boolean;
  /** 割当不可 session の更新（setNotAllocSessionId）をするか */
  updateNotAllocSession: boolean;
  /** 未割当パネルの選択復帰（setPendingNotAllocSelect）をするか */
  restoreNotAllocSelection: boolean;
  /** 完了通知を出すか */
  notify: boolean;
};

/**
 * 現行の 3 経路をそのまま表にしたもの。
 *
 * Why not controller に持たせる: override は画面所有で、`/map` は持たない。
 * Why not queued でも clearOverride を返す: queued は controller が
 * `shouldClearLocalOverrides` 経由で処理済み。ここで重ねると二重に消す。
 */
export function resolveCompletionEffects(
  mode: AutoDispatchMode,
  kind: CompletionKind,
): CompletionEffects {
  // 純 unassign（:1835-1841）。override を消すだけで、session も通知も触らない
  if (kind === 'skipped') {
    return {
      clearOverride: true,
      updateNotAllocSession: false,
      restoreNotAllocSelection: false,
      notify: false,
    };
  }
  if (kind === 'queued') {
    return {
      clearOverride: false, // controller が処理済み
      updateNotAllocSession: true,
      restoreNotAllocSelection: true,
      notify: true,
    };
  }
  // immediate。timeline だけ override を残す（:2014-2021 に override 操作が無い）
  return {
    clearOverride: mode !== 'timeline',
    // timeline の即時完了は割当不可 ID を返さないので session も触らない
    updateNotAllocSession: mode !== 'timeline',
    restoreNotAllocSelection: false, // 現行は queued 経路（:1360）にしかない
    notify: true,
  };
}
